module.exports = __webpack_public_path__ + "陈智强-066ecd6a.png";